import {Box, Flex} from '@chakra-ui/react';
import Sidebar from './Sidebar';
import MobileTopNav from './MobileTopNav';
import UniversityExperience from './university/UniversityExperience';
import UniversitySafetyBoundary from './university/UniversitySafetyBoundary';

// Match the native client: phone and portrait/small-tablet layouts use a
// bottom tab bar; the hover rail begins at the same `lg` breakpoint as the
// planner's landscape master/detail layout.
const AppShell = ({children, scrollContent = false}: Record<string, any>) => (
  <Flex
    h="100vh"
    minH={0}
    direction="column"
    overflow="hidden"
    sx={{height: '100dvh'}}
  >
    <Flex flex={1} minH={0} minW={0} overflow="hidden">
      <Sidebar placement="inline" />
      <Box
        flex={1}
        minH={0}
        minW={0}
        overflow={scrollContent ? 'auto' : 'hidden'}
        borderBottomRadius={{base: 'xl', lg: 0}}
        position="relative"
        zIndex={1}
      >
        {children}
      </Box>
    </Flex>
    <MobileTopNav />
    {/* Opalite University: per-route video tips + guided /start welcome. */}
    <UniversitySafetyBoundary>
      <UniversityExperience />
    </UniversitySafetyBoundary>
  </Flex>
);

export default AppShell;
